export const DATE_FORMAT = 'YYYY-MM-DD'
export const HUMAN_DATE_FORMAT = 'DD/MM/YYYY'
export const TIME_FORMAT = 'HH:mm'
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const HUMAN_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm'
export const HUMAN_DATETIME_2_DIGIT_FORMAT = 'DD/MM/YY HH:mm'
export const MONTH_FORMAT = 'YYYY-MM'
export const YEAR_FORMAT = 'YYYY'
